import React, { createContext, useContext } from 'react';

export type FilterLayout = 'sidebar' | 'tray' | 'inline' | 'bar';

const FilterLayoutContext = createContext<FilterLayout | undefined>(undefined);

/**
 * PD-15743 — tells the filter controls beneath it which surface they are on.
 *
 * `FilterGroup` already passes `layout` down to every registered filter it
 * renders, so it has no need of this. The report pages are the gap: they
 * build their own filter control and hand it to `FilterSidebar` as a pinned
 * child, which lands it in the header bar without ever saying so. Some of
 * them wrap it in a div first, so cloning the child cannot reach the control
 * reliably — a context can, at any depth.
 */
export function FilterLayoutProvider({
	layout,
	children,
}: {
	layout: FilterLayout;
	children: React.ReactNode;
}): React.JSX.Element {
	return (
		<FilterLayoutContext.Provider value={layout}>
			{children}
		</FilterLayoutContext.Provider>
	);
}

/** The surface the surrounding filter controls are rendered on, if declared. */
export function useFilterLayout(): FilterLayout | undefined {
	return useContext(FilterLayoutContext);
}
